import * as type from "../types/invitation";

const initialState = {
  validationStatus: null,
  validationLoading: false,
  validationError: null,
  invitationDetails: {
    email: null,
    organizationNumber: null,
  },
};

export const invitation = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_VALIDATE_INVITATION:
      return {
        ...state,
        validationStatus: null,
        validationLoading: true,
        validationError: null,
      };
    case type.REVOKE_VALIDATE_INVITATION:
      return {
        ...state,
        validationStatus: null,
        validationLoading: false,
        validationError: payload.message,
      };
    case type.GRANT_VALIDATE_INVITATION:
      return {
        ...state,
        validationStatus: "success",
        validationLoading: false,
        validationError: null,
        invitationDetails: {
          ...state.invitationDetails,
          email: payload.data.email,
          organizationNumber: payload.data.organizationNumber,
        },
      };
    case type.RESET_VALIDATE_INVITATION:
      return {
        ...state,
        validationStatus: null,
        validationLoading: false,
        validationError: null,
      };
    default:
      return state;
  }
};
